export const EMAIL_FIELD_NAME = 'email'
export const PASSWORD_FIELD_NAME = 'password'
export const EMAIL_FIELD_ID = 'login-email-field'
export const PASSWORD_FIELD_ID = 'login-password-field'
export const KEEP_ME_LOGGED_IN = 'keep-me-logged-in'
